import { MutationTree } from "vuex";
import { LDAPAddress, LDAPManagementState, LDAPPort } from "./types";
import { getDefaultState } from "./state";
import _ from "lodash";
import Vue from "vue";

export const mutations: MutationTree<LDAPManagementState> = {
	setAddresses(state, data: LDAPAddress[]) {
		state.ldapAddresses.push(...data);
	},
	resetAddresses(state) {
		state.ldapAddresses = [];
	},
	addNewLDAPAddress(state, data: LDAPAddress) {
		state.ldapAddresses.push(data);
	},
	removeAddress(state, address: string) {
		const index: number = state.ldapAddresses.findIndex(x => _.isEqual(x.address, address));
		if (index >= 0) {
			state.ldapAddresses.splice(index, 1);
		}
	},
	updateLDAPAddress(state, { oldAddress, newAddress }) {
		const currentIndex: number = state.ldapAddresses.findIndex(x => x.address == oldAddress);
		if (currentIndex >= 0) {
			Vue.set(oldAddress, currentIndex, newAddress);
		}
	},
	setLDAPPort(state, data: LDAPPort) {
		state.ldapPort = data;
	},
	resetLDAPPort(state) {
		state.ldapPort = null;
	},
	updateLDAPPort(state, newPort: LDAPPort) {
		state.ldapPort = newPort;
	},
	resetState(state) {
		Object.assign(state, getDefaultState());
	},
};